import { AfterViewInit,Component, Inject, Optional, OnInit,ViewChild } from '@angular/core';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';
import { MatTable } from '@angular/material/table';
import { TipoEvaluacionService } from 'app/main/services/tipo-evaluacion.service';
import { EscenarioService } from 'app/main/services/escenario.service';
import { EstructuraJerarquicaService } from 'app/main/services/estructura-jerarquica.service';
import { UsersService } from 'app/main/services/users.service';
import { NodeSelectorDialogBoxComponent} from 'app/main/apps/estructura-jerarquica/dialog/node-selector-dialog-box.component';
import {TranslateService} from '@ngx-translate/core';



//import { MatSort } from '@angular/material/sort';
import { Escenario } from 'app/main/models/escenario.model';
import {MatCalendar} from '@angular/material/datepicker';
import {DateAdapter, MAT_DATE_FORMATS,MAT_DATE_LOCALE, MatDateFormats} from '@angular/material/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
//import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
/*
import * as _moment from 'moment';
import {default as _rollupMoment} from 'moment';
const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

*/

@Component({
  selector: 'app-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.scss'],
  /*providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]*/
})
export class DialogBoxComponent {

  colorScheme = {
    domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
  };

  action: string;
  LOCAL_DATA: any;
  tiposEvaluacion = [];
  estructuraJerarquicas = [];
  escenarios = [];
  nodosEstructuraJerarquica = [];
  usuarios = [];

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<DialogBoxComponent>,
    public serviceTipoEvaluacion:TipoEvaluacionService,
    public serviceEscenarios:EscenarioService,
    public serviceEstructuraJerarquica:EstructuraJerarquicaService,
    public userService: UsersService,
    public translate: TranslateService,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Escenario) {
    console.log(data);
    this.LOCAL_DATA = {...data};
    this.action = this.LOCAL_DATA.action;
    //Object.assign(this, { multi });
  }

  doAction(): void{
    console.log('im here');
    this.dialogRef.close({event: this.action, data: this.LOCAL_DATA});
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }


  openDialog(): void {
    var obj = {};
    const dialogRef = this.dialog.open(NodeSelectorDialogBoxComponent, {
      width: '100%',
      data: obj,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.LOCAL_DATA.nodoEstructuraJerarquica = result.data.nodo;
      this.LOCAL_DATA.estructuraJerarquica = result.data.estructura;

    });
  }

  ngOnInit(): void {

    this.serviceTipoEvaluacion.getAll(0,1000).pipe().subscribe(req => {
      this.tiposEvaluacion = req.body.map( tipo => {
        console.log(tipo);
        return {
          id: tipo.id,
          nombre: tipo.nombre
        };
      });
    });

    this.serviceEscenarios.getAll(0,1000).pipe().subscribe(req => {
      this.escenarios = req.body.map( tipo => {
        console.log(tipo);
        return {
          id: tipo.id,
          nombre: tipo.nombre
        };
      });
    });

    this.serviceEstructuraJerarquica.getAll(0,1000).pipe().subscribe(req => {
      this.estructuraJerarquicas = req.body.map( tipo => {
        console.log(tipo);
        return {
          id: tipo.id,
          nombre: tipo.nombre,
          nodos: tipo.nodos
        };
      });
    });

    this.userService.getAll(0,1000).pipe().subscribe(req => {
      this.usuarios = req.body.map( user => {
        console.log(user);
        return {
          id: user.id,
          nombre: user.nombre,
          apellido: user.apellido,
          nombreCompleto: user.nombreCompleto,
          correoElectronico: user.correoElectronico,
          tipo: user.tipo,
          active: user.active
        };
      });
    });
  }

}
